import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import {
  Box,
  CircularProgress,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { getUserById, getUserEarnings } from "../apis";
import moment from "moment";

const MyEarnings = () => {
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState(null);
  const [earningsData, setEarningsData] = useState([]);
  const [totalEarning, setTotalEarning] = useState(0);
  const [thisMonthEarning, setThisMonthEarning] = useState(0);

  let user = {};
  user = JSON.parse(localStorage.getItem("user-info"));
  let userID = user.googleId ? user.googleId : user._id;
  useEffect(() => {
    const fetchData = async () => {
      let total = 0;
      let thismonth = 0;
      let d = new Date();
      let month = d.getMonth();
      const response = await getUserById(userID);
      const earningsResult = await getUserEarnings(userID);
      setUserInfo(response.data.serviceProviderInfo);
      setEarningsData(earningsResult.data.earningsData);

      earningsResult.data.earningsData.map((item) => {
        total = total + item.earning;
      });
      setTotalEarning(total);

      const filteredData = earningsResult.data.earningsData.filter(
        (item) => moment(item.createdAt).utc().format("MM") == month + 1
      );
      filteredData.map((item) => {
        thismonth = thismonth + item.earning;
      });
      setThisMonthEarning(thismonth);
      setLoading(false);
    };
    fetchData();
  }, []);

  return (
    <>
      <Navbar />
      {loading ? (
        <Box
          sx={{ display: "flex" }}
          justifyContent="center"
          alignItems="center"
          style={{ height: "80vh" }}
        >
          <CircularProgress disableShrink />
        </Box>
      ) : (
        <>
          <Container>
            <Stack
              direction="row"
              spacing={3}
              alignItems="center"
              className="mt-5"
            >
              <div
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "100%",
                  border: "1px solid white",
                }}
              >
                <img
                  src={userInfo.personalInfo.image[0]}
                  alt="profile picture"
                  style={{
                    height: "100px",
                    width: "100px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <Stack spacing={2}>
                <Typography style={{ fontSize: "20px", fontWeight: "bold" }}>
                  {user.fullName}
                </Typography>
                <Typography className="ammanat-darker-gray">
                  {user.email}
                </Typography>
              </Stack>
            </Stack>

            <Stack spacing={2} className="mt-16">
              <Typography
                style={{ fontSize: "20px", fontWeight: "bold" }}
                className="mt-10"
              >
                Description
              </Typography>
              <Typography className="ammanat-darker-gray">
                {userInfo.personalInfo.description}
              </Typography>
            </Stack>

            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="mt-16"
            >
              <Stack spacing={2}>
                <Typography
                  style={{ fontSize: "20px", fontWeight: "bold" }}
                  className="mt-10"
                >
                  This Month's Earning
                </Typography>
                <Typography className="ammanat-darker-gray">
                  £{thisMonthEarning}
                </Typography>
              </Stack>
              <Stack spacing={2}>
                <Typography
                  style={{ fontSize: "20px", fontWeight: "bold" }}
                  className="mt-10"
                >
                  Total Earnings
                </Typography>
                <Typography className="ammanat-darker-gray">
                  £{totalEarning}
                </Typography>
              </Stack>
            </Stack>
          </Container>
        </>
      )}
    </>
  );
};

export default MyEarnings;
